import { useFormik } from "formik";
import { motion } from "framer-motion";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import edit from '../../../../../../../../assets/images/edit.svg';
import SelectCustom from "../../../../../../../../components/SelectCustom";
import Loading from "../../../../../../../../core/common/Loading";
import {
  formatDateBR,
  maskedCPF,
  maskedPhone,
} from "../../../../../../../../helpers/format";
import { useModal } from "../../../../../../../../hooks/ModalContext";
import { useStatus } from "../../../../../../../../hooks/StatusContext";
import api from "../../../../../../../../services/api";
import { FrontendNotification } from "../../../../../../../../shared/Notification";
import Create from "../../../../../../Cadastro/Motoristas/Create";
import { IMotorista } from "../../../../../../Cadastro/Motoristas/Create/types/types";
import formValidator from "./validators/formValidator";
import CheckIcon from '@mui/icons-material/Check';
import { useAuth } from "../../../../../../../../hooks/AuthenticateContext";
// import { Container } from './styles';

interface FormValues {
  id_motorista: string;
  cpf_motorista: string;
}

const IdentifyDriver: React.FC = () => {
  const { closeModal } = useModal();
  const [loading, setLoading] = useState<boolean>(false);
  const [, setListDriver] = useState([]);
  const [detailDriver, setDetailDriver] = useState<IMotorista[]>([]);
  const [, setSearchQuery] = useState<string>('');
  const [searchDriver, setSearchDriver] = useState();
  const [showCreateDriver, setShowCreateDriver] = useState<boolean>(false);
  const [showUpdatePhone, setShowUpdatePhone] = useState<boolean>(false);
  const [textPhone, setTextPhone] = useState<string>('');
  const [isAssociate, setIsAssociate] = useState<boolean>(false);
  const { user } = useAuth();

  const selectRef: any = useRef(null);

  const pageVariants = {
    initial: { opacity: 0, x: 100 },
    animate: { opacity: 1, x: 0, transition: { duration: 0.8 } },
    exit: { opacity: 0, x: 100, transition: { duration: 0.5 } },
  };

  const detailDriverVariants = {
    initial: { opacity: 0, y: -100 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.8 } },
    exit: { opacity: 0, y: 100, transition: { duration: 0.5 } },
  };

  const { setStatus } = useStatus();

  const onDelete = useCallback(async () => {
    try {
      setLoading(true);

      let currentRow: any = localStorage.getItem("@triagem");

      if (currentRow) {
        currentRow = JSON.parse(currentRow);
      }

      const idOperacaoPatio = localStorage.getItem("id_operacao_patio");

      const id =
        idOperacaoPatio && idOperacaoPatio.length > 0
          ? idOperacaoPatio
          : currentRow.id_operacao_patio;

      const body = {
        id_operacao_patio: Number(id),
      };

      await api.post("/deletar/desassociarTriagem", body);

      
      setLoading(false);
      
      setStatus(0);

    } catch {
      setLoading(false);
    }
  }, []);


  const handleSubmit = useCallback(async (values: FormValues, isAssociate: boolean) => {
    try {
      setLoading(true);

      let currentRow: any = localStorage.getItem("@triagem");

      if (currentRow) {
        currentRow = JSON.parse(currentRow);
      }

      const idOperacaoPatio = localStorage.getItem("id_operacao_patio");

      const id =
        idOperacaoPatio && idOperacaoPatio.length > 0
          ? idOperacaoPatio
          : currentRow.id_operacao_patio;

      const body = {
        id_operacao_patio: id,
        id_motorista: values.id_motorista,
        id_usuario_historico: user?.id,
        status: 4,
      };

      const response = await api.post(
        "/operacaopatio/confirmDriverIdentity",
        body
      );

      if (response.status === 200) {
        localStorage.setItem("id_operacao_patio", response.data.id_operacao_patio);
        localStorage.setItem("@triagem", JSON.stringify(response.data));

        if(isAssociate) {
          closeModal();
        } else { 
          setStatus(2);
        }
      } else {
        FrontendNotification("Erro ao identificar o motorista", "error");
      }

      setLoading(false);
    } catch {
      setLoading(false);
      FrontendNotification("Erro ao identificar o motorista", "error");
    }
  }, []);

  const onSearchDetailDriver = useCallback(async (cpf: string) => {
    try {
      setLoading(true);

      const body = {
        cpf,
      };

      const response = await api.post("/operacaopatio/searchDriver", body);

      if (response.status === 200) {
        if (response.data) {
          const data = [];

          data.push(response.data);

          setDetailDriver(data);

          setTextPhone(response.data.celular);

          let getDataTriagem: any = localStorage.getItem("@triagem");
          if (getDataTriagem) {
            getDataTriagem = JSON.parse(getDataTriagem);
          }

          if (
            getDataTriagem &&
            getDataTriagem.operacao_porto_agendada !== null &&
            response.data
          ) {
            formik.setFieldValue("id_motorista", response.data.id_motorista);

          }
        } else {

          FrontendNotification('Não foi possivel encontrar o motorista com o CPF informado!', 'warning');
        }
      } else {
        FrontendNotification('Não foi possivel encontrar o motorista com o CPF informado!', 'warning');
      }

      setLoading(false);
    } catch {
      setLoading(false);
    }
  }, []);

  const onLoadFormValues = useCallback(() => {
    let getDataTriagem: any = localStorage.getItem("@triagem");
    if (getDataTriagem) {
      getDataTriagem = JSON.parse(getDataTriagem);
    }


    if (getDataTriagem && getDataTriagem.operacao_porto_agendada !== null) {
      formik.setFieldValue(
        "cpf_motorista",
        getDataTriagem.operacao_porto_agendada.cpf_motorista
      );

      onSearchDetailDriver(
        getDataTriagem.operacao_porto_agendada.cpf_motorista
      );
    }
  }, []);

  const onSearchDriver = useCallback(async (value: string) => {
    try {
      setLoading(true);

      if (value.length > 0) {
        const body = {
          order_by: "data_historico",
          order_direction: "desc",
          qtd_por_pagina: 100,
          cpf: value,
        };

        const response = await api.post("/listar/motoristas", body);

        const mappingResponse = response.data.data.map((item: IMotorista) => {
          return {
            label: `${maskedCPF(item.cpf)} | ${item.nome}`,
            cpf: item.cpf,
            value: item.id_motorista,
          };
        });

        setListDriver(mappingResponse);
        setLoading(false);

        return mappingResponse;
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  }, []);

  const onUpdatePhone = useCallback(async (id_motorista: number, value: string) => {
    try {
      setLoading(true);

      console.log(value);

      const body = {
        celular: value,
        id_motorista: id_motorista,
      };

      const response = await api.post(`/operacaopatio/trocaTelefone`, body);

      if (response.status === 200) {
        FrontendNotification('Telefone alterado com sucesso!', 'success');
        setShowUpdatePhone(false);
        if(formik.values.cpf_motorista.length > 0) {
          onSearchDetailDriver(formik.values.cpf_motorista);
        }

      } else {
        FrontendNotification('Erro ao alterar o telefone!', 'error');
      }

      setLoading(false);
    } catch {
      setLoading(false);
    }
  }, [])

  const initialValues: FormValues = {
    id_motorista: "",
    cpf_motorista: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: formValidator,
    onSubmit: (values: FormValues) => {
      if (detailDriver.length > 0) {
        handleSubmit(values, isAssociate);
      }
    },
  });

  const loadOptions = async (inputValue: string, callback: any) => {
    if (inputValue.length < 3) {
      // Não carrega nada se menos de 3 caracteres
      callback([]);
      return;
    }

    return await onSearchDriver(inputValue)
  };

  useEffect(() => {
    onLoadFormValues();
  }, [onLoadFormValues]);

  return (
    <>
      <ToastContainer />
      {showCreateDriver && (
        <Create
          isView={false}
          isEdit={false}
          onClear={() => {
            setShowCreateDriver(!showCreateDriver);
          }}
          onConfirm={() => {
            setShowCreateDriver(!showCreateDriver);
          }}
        />
      )}
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageVariants}
        className="page"
      >
        <Loading loading={loading} skeletonVariant="card" skeletonFields={6} skeletonAvatar />
        <div className="overflow-y-scroll max-h-[calc(90vh)] p-5">
          <div className="flex mb-3 mt-3">

            <div className="flex flex-col mb-3 mt-3">
              <span className="text-sm text-[#000] font-bold">
                Identificação de motorista
              </span>
              <span className="text-sm text-[#666666] font-normal mt-3">
                Procura do cadastro de motorista no sistema
              </span>
            </div>
            <button
              type="button"
              className="w-28 h-9 ml-4 pl-3 pr-3 flex items-center justify-center bg-[#0A4984] text-sm text-[#fff] font-bold rounded-full mr-2"
              onClick={() => setShowCreateDriver(!showCreateDriver)}
              id="btnCreateDriver"
            >
              + Adicionar
            </button>
          </div>
          <div className="grid grid-cols-2 gap-3 mb-6">
            <div className="flex items-center w-full">
              <div className="w-full">
                <SelectCustom
                  id="id_motorista"
                  async
                  selectRef={selectRef}
                  data={loadOptions}
                  onChange={(selectedOption: any) => {
                    setSearchDriver(selectedOption);
                    formik.setFieldValue("id_motorista", selectedOption.value);
                    formik.setFieldValue("cpf_motorista", selectedOption.cpf);
                  }}
                  onInputChange={(value) => {
                    setSearchQuery(value);
                  }}
                  title="CPF do Motorista"
                  touched={formik.touched.id_motorista}
                  error={formik.errors.id_motorista}
                  value={formik.values.cpf_motorista}
                  defaultValue={searchDriver}
                />
              </div>
              <button
                className="w-full max-w-28 h-10 flex items-center justify-center border-none rounded-full bg-[#0A4984] text-base text-[#fff] font-bold mt-6 ml-3 cursor-pointer"
                type="button"
                onClick={() => {
                  if (String(formik.values.cpf_motorista).length > 0) {
                    onSearchDetailDriver(formik.values.cpf_motorista);
                  }
                }}
                id="btnSearchDriver"
              >
                Procurar
              </button>
            </div>
          </div>
          {detailDriver.length > 0 && (
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={detailDriverVariants}
              className="page"
            >
              <div className="w-full h-[1px] bg-[#0A4984] mb-4" />
              <div className="flex flex-col mb-3 mt-3">
                <span className="text-sm text-[#000] font-bold">
                  Dados do motorista
                </span>
                <span className="text-sm text-[#666666] font-normal mt-3">
                  Dados do cadastro do motorista no sistemas
                </span>
              </div>
              <div className="w-2/3 h-full flex">
                <div className="w-full grid grid-cols-2 gap-3">
                  {detailDriver.map((item: IMotorista) => (
                    <React.Fragment>
                      <div className="flex flex-col items-start">
                        <span className="text-sm text-[#1E2121] font-bold mt-2">
                          CPF
                        </span>
                        <span className="text-sm text-[#1E2121] font-light mt-1">
                          {item.cpf && item.cpf.length > 0
                            ? maskedCPF(item.cpf)
                            : "---"}
                        </span>
                      </div>
                      <div className="flex flex-col items-start">
                        <span className="text-sm text-[#1E2121] font-bold mt-2">
                          Nome
                        </span>
                        <span className="text-sm text-[#1E2121] font-light mt-1">
                          {item.nome}
                        </span>
                      </div>
                      <div className="flex flex-col items-start">
                        <span className="text-sm text-[#1E2121] font-bold mt-2">
                          Cidade | Estado
                        </span>
                        <span className="text-sm text-[#1E2121] font-light mt-1">
                          {item.cidade !== null ? item.cidade : "---"}{" "}
                          {item.uf_estado !== null ? item.uf_estado : ""}
                        </span>
                      </div>
                      <div className="flex flex-col items-start">
                        <span className="text-sm text-[#1E2121] font-bold mt-2">
                          Celular
                        </span>
                        <div className="flex items-center">
                          {!showUpdatePhone ? (
                            <>

                              <span className="text-sm text-[#1E2121] font-light mt-1">
                                {item.celular && item.celular.length > 0
                                  ? maskedPhone(item.celular)
                                  : "---"}

                              </span>
                              <img className="ml-2 cursor-pointer" src={edit} alt="" onClick={() => setShowUpdatePhone(!showUpdatePhone)} />
                            </>
                          ) : (
                            <div className="flex items-center">
                              <input type="text" className="w-full h-9" value={textPhone} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTextPhone(e.target.value)} />

                              {/* <img className="ml-2 cursor-pointer" src={deleteIcon} alt="" onClick={() => setShowUpdatePhone(!showUpdatePhone)} /> */}

                              <CheckIcon
                                className="ml-2 relative -top-2 cursor-pointer"
                                style={{
                                  fill: 'green'
                                }}
                                onClick={() => {
                                  onUpdatePhone(Number(formik.values.id_motorista), textPhone)
                                }}
                                id="btnUpdatePhone"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex flex-col items-start">
                        <span className="text-sm text-[#1E2121] font-bold mt-2">
                          CNH | Categoria | Data Expiração
                        </span>
                        <span className="text-sm text-[#1E2121] font-light mt-1">
                          {item.numero_cnh && item.numero_cnh !== null
                            ? `${maskedCPF(item.numero_cnh)} |`
                            : "---"}{" "}
                          {item.categoria_cnh && item.categoria_cnh !== null
                            ? `${item.categoria_cnh} |`
                            : "---"}{" "}
                          {item.data_expiracao_cnh &&
                            item.data_expiracao_cnh !== null
                            ? formatDateBR(item.data_expiracao_cnh)
                            : "---"}
                        </span>
                      </div>
                      <div className="flex flex-col items-start">
                        <span className="text-sm text-[#1E2121] font-bold mt-2">
                          Situação
                        </span>
                        <span className="text-sm text-[#1E2121] font-light mt-1">
                          OK
                        </span>
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              </div>
              <div className="w-full h-[2px] bg-[#DBDEDF] mt-4" />
              <div className="flex flex-col mb-3 mt-6">
                <span className="text-sm text-[#000] font-bold">
                  Confirmação da identidade
                </span>
                <span className="text-sm text-[#666666] font-normal mt-2">
                  O funcionário deve confirmar a identidade por verificação de
                  documentos com fotos e demais protocolos definidos.
                </span>
              </div>
            </motion.div>
          )}
        </div>
      </motion.div>
      <div className="sticky bottom-0 w-full h-14 flex items-center justify-end bg-[#FFFFFF] shadow-xl">
        <button
          type="button"
          className="w-24 h-9 pl-3 pr-3 flex items-center justify-center bg-[#F9FAFA] text-sm text-[#000] font-bold rounded-full mr-2 shadow-md"
          onClick={() => onDelete()}
          style={{ border: '1px solid #DBDEDF' }}
          id="btnBack"
        >
          Voltar
        </button>

        <button
          type="button"
          className="w-36 h-9 pl-3 pr-3 flex items-center justify-center bg-[#F9FAFA] text-xs text-[#000] font-bold rounded-full mr-2 shadow-md"
          onClick={() => {
            setIsAssociate(true);
            formik.handleSubmit();
          }}
          style={{ border: "1px solid #DBDEDF" }}
          id="btnWaitCall"
        >
          Aguardar Chamada
        </button>
        <button
          type="button"
          className="w-24 h-9 pl-3 pr-3 flex items-center justify-center bg-[#0A4984] text-sm text-[#fff] font-bold rounded-full mr-2"
          onClick={() => formik.handleSubmit()}
          id="btnNext"
        >
          Avançar
        </button>
      </div>
    </>
  );
};

export default IdentifyDriver;
